import { render, staticRenderFns } from "./hearingAidDetail.vue?vue&type=template&id=37dad90d&scoped=true&"
import script from "./hearingAidDetail.vue?vue&type=script&lang=js&"
export * from "./hearingAidDetail.vue?vue&type=script&lang=js&"
import style0 from "./hearingAidDetail.vue?vue&type=style&index=0&id=37dad90d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dad90d",
  null
  
)

export default component.exports